<div class="m-auto mt-5 col-11">
  <h2>Impostazioni</h2>
</div>